/* eslint-disable better-mutation/no-mutation */
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

type TemplateState = {
    ignoreProperties: string[];
};

const initialState: TemplateState = {
    ignoreProperties: []
};

const templateReducer = createSlice({
    name: 'template',
    initialState,
    reducers: {
        resetIgnoreProperties: (state) => {
            state.ignoreProperties = [];
        },
        addIgnoreProperties: (state, action: PayloadAction<string[]>) => {
            state.ignoreProperties = [
                ...new Set([...state.ignoreProperties, ...action.payload])
            ];
        },
        removeIgnoreProperties: (state, action: PayloadAction<string[]>) => {
            state.ignoreProperties = state.ignoreProperties.filter(
                (prop) => !action.payload.includes(prop)
            );
        }
    }
});

export const {
    resetIgnoreProperties,
    addIgnoreProperties,
    removeIgnoreProperties
} = templateReducer.actions;

export default templateReducer.reducer;
